module.exports = __webpack_public_path__ + "static/media/trending_footer.bb933cfa.svg";